module.exports = __webpack_public_path__ + "static/media/Network.bce60030.png";